import { IExternalConsentService } from '@app/interfaces/interfaces';
import { AxiosResponse } from 'axios';
import { httpApi } from '../config/http.api';

const BASE_SUB_PATH = 'transparency';

export const postRemoteConsentApi = (data: IExternalConsentService[]): Promise<AxiosResponse> =>
  httpApi.post<AxiosResponse>(`${BASE_SUB_PATH}/grantConsent`, data);
